/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__account_modal_save_pref = /** @type {(inputs: {}) => string} */ () => {
	return `Speichern Sie Ihre Routenpräferenzen`
};

const en_launchpad__account_modal_save_pref = /** @type {(inputs: {}) => string} */ () => {
	return `Save your route preferences`
};

const es_launchpad__account_modal_save_pref = /** @type {(inputs: {}) => string} */ () => {
	return `Guarde sus preferencias de ruta`
};

const fr_launchpad__account_modal_save_pref = /** @type {(inputs: {}) => string} */ () => {
	return `Enregistrez vos préférences de trajets`
};

const it_launchpad__account_modal_save_pref = /** @type {(inputs: {}) => string} */ () => {
	return `Salva le tue preferenze di percorso`
};

const nl_launchpad__account_modal_save_pref = /** @type {(inputs: {}) => string} */ () => {
	return `Sla uw routevoorkeuren op`
};

const pt_launchpad__account_modal_save_pref = /** @type {(inputs: {}) => string} */ () => {
	return `Guarde as suas preferências de trajeto`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_save_pref = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__account_modal_save_pref(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__account_modal_save_pref", locale)
	if (locale === "de") return de_launchpad__account_modal_save_pref(inputs)
	if (locale === "en") return en_launchpad__account_modal_save_pref(inputs)
	if (locale === "es") return es_launchpad__account_modal_save_pref(inputs)
	if (locale === "fr") return fr_launchpad__account_modal_save_pref(inputs)
	if (locale === "it") return it_launchpad__account_modal_save_pref(inputs)
	if (locale === "nl") return nl_launchpad__account_modal_save_pref(inputs)
	return pt_launchpad__account_modal_save_pref(inputs)
};